<template>
  <div class="modal-background"></div>
  <div v-if="showConfirmationModal === false" class="modal-container">
      <img style="margin-top: 15%; width: 60%;"
          src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/339ebd0c-ec87-4c3f-a10b-62d993620c36.svg"
          class="icon" alt="">

      <p style="font-weight: bold;">Programa Entrelaços</p>
      <p style="width: 90%; margin-left: 5%; margin-top: 5px;font-size: 10px">O seu retorno é muito importante pra gente. Preparamos um programa de acompanhamento pensado para atender as suas necessidades.<br><br> Aceita participar deste encontro?</p>

      <div style="display: flex; width: 90%; margin-left: 5%; justify-content: space-between;">
        <v-btn class="text-none" flat @click="acceptEntrelacos()" color="#660099" style="margin-top: 20px; width:45%">Sim</v-btn>
        <v-btn class="text-none" flat @click="showConfirmationModal = true" style="margin-top: 20px; width:45%; border: solid 1px #660099; color: #660099;">Não</v-btn>
      </div>
  </div>
  <div v-else class="modal-container">
      <img style="margin-top: 15%; width: 60%;"
          src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/339ebd0c-ec87-4c3f-a10b-62d993620c36.svg"
          class="icon" alt="">

      <p style="font-weight: bold;">Programa Entrelaços</p>
      <p style="width: 90%; margin-left: 5%; margin-top: 5px;font-size: 10px">Essa é uma oportunidade única. Você tem certeza que não quer participar?</p>

      <div style="display: flex; width: 90%; margin-left: 5%; justify-content: space-between; position: absolute; bottom: 7%;">
        <v-btn class="text-none" flat @click="showConfirmationModal = false" color="#660099" style="margin-top: 20px; width:45%">Não</v-btn>
        <v-btn class="text-none" flat @click="recuseEntrelacos()" style="margin-top: 20px; width:45%; border: solid 1px #660099; color: #660099;">Sim</v-btn>
      </div>
  </div>
</template>

<script setup>
import { defineEmits, ref, onMounted } from 'vue';
const emit = defineEmits(["close-modal-accepting", "close-modal"])
import { useGlobalStateStore, useFelixBagAuxStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();
const felixBagAuxStore = useFelixBagAuxStore();

onMounted(() => {
  felixBagAuxStore.pauseVideo()
});

const showConfirmationModal = ref(false)

function acceptEntrelacos() {
  globalStateStore.globalState.selectedData.acceptedEntrelacos = true
  emit('close-modal-accepting')
}

function recuseEntrelacos() {
  globalStateStore.globalState.selectedData.acceptedEntrelacos = false
  emit('close-modal')
}

</script>

<style scoped>
.modal-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 4;
  background-color: black;
  opacity: 0.4;
}

.modal-container {
  position: absolute;
  width: 90%;
  height: 62%;
  border-radius: 12px;
  background-color: #fff;
  top: 15%;
  left: 5%;
  z-index: 4;
}

.close {
  position: absolute !important;
  left: 75%;
  top: 2%;
}

.close img {
  width: 20px;
}
</style>